// extracted by mini-css-extract-plugin
export var banner = "styles-module__banner___KkRx8";
export var bulletList = "styles-module__bulletList____yomY";
export var checkMarkIcon = "styles-module__checkMarkIcon____2f6s";
export var container = "styles-module__container___bDuYi";
export var desktopBulletList = "styles-module__desktopBulletList___dbQKQ";
export var featureHeader = "styles-module__featureHeader___jX1ed";
export var features = "styles-module__features___M0gdZ";
export var featuresAndChoose = "styles-module__featuresAndChoose___MtbUz";
export var mobileBulletList = "styles-module__mobileBulletList___LGYxg";
export var planType = "styles-module__planType___tUx8J";